/**
 * v3.19-1423 COMMS-MODERN Phase 2 · Tiny safe rich-text renderer.
 *
 * Purpose: render bulletin bodies with lightweight formatting without
 * pulling in a full markdown/sanitizer dependency.  Supported:
 *   • **bold**
 *   • *italic*
 *   • `code`
 *   • URLs (http/https) auto-linked
 *   • line breaks preserved (whitespace-pre-wrap)
 *
 * SECURITY: input is escaped BEFORE any format-token processing so raw
 * HTML in the source can never render as HTML.  The output is a string
 * safe to place inside `dangerouslySetInnerHTML` on a container that
 * uses `whitespace-pre-wrap` for line handling.
 */
export function escapeHtml(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

// Auto-link http/https URLs. Matches non-whitespace, non-'<>()' runs
// starting with http:// or https:// so trailing punctuation like ")"
// doesn't get sucked into the URL.
const URL_RE = /(https?:\/\/[^\s<>()]+)/g;

export function renderRichText(src) {
  if (!src) return '';
  let out = escapeHtml(src);
  // bold + italic + code — escape-safe because we operate on already-escaped
  // text; the tokens are the same characters in both worlds.
  out = out.replace(/\*\*([^*\n][^*\n]*)\*\*/g, '<strong>$1</strong>');
  out = out.replace(/(^|[\s(])\*([^*\n][^*\n]*)\*(?=[\s.,;:)!?]|$)/g,
                    '$1<em>$2</em>');
  out = out.replace(/`([^`\n]+)`/g,
                    '<code class="px-1 py-0.5 rounded bg-slate-100 text-[12.5px] font-mono">$1</code>');
  out = out.replace(URL_RE,
    '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-indigo-700 hover:underline break-all">$1</a>');
  return out;
}
